import PropTypes from 'prop-types';
import React from 'react';

import './AccountPageHeader.scss';
import { DockableHeader } from 'v5/patterns/sidebar/DockableLayout';
import { HamburgerMenu } from 'v5/features/core/HamburgerMenu';

const AccountPageHeader = ({ label, title, description }) => (
  <div className="AccountPageHeader">
    <div className="tailwind-root contents">
      <DockableHeader>
        <div className="pt-2.5 p-2 fixed left-0 top-0">
          <HamburgerMenu />
        </div>
      </DockableHeader>
    </div>
    {label && <p className="AccountPageHeader-subtitle">{label}</p>}
    {title && <h1 className="AccountPageHeader-title emulate-h2">{title}</h1>}
    {description && <p>{description}</p>}
  </div>
);

AccountPageHeader.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string
};

export default AccountPageHeader;
